<template>
  <el-main class="container">
    <Nav>
      <div slot="left" class="left">
        <el-input
          v-model="body.word"
          clearable
          class="input-text"
          maxlength="30"
          placeholder="请输入订单号/企业名称进行搜索"/>
          <el-button
            @click="event().search()"
            type="primary">搜索</el-button>
          <div class="status">
            <span>状态筛选</span>
            <el-select
              slot="prepend"
              class="select"
              v-model="selectStatus"
              placeholder="选择状态"
              @change="event().selectFn($event)">
              <el-option
                  v-for="(item,index) in status"
                  :key="index"
                  :value="item"></el-option>
            </el-select>
          </div>
      </div>
      <div
        class="right"
        slot="right">
        <el-button
          type="primary"
          class="excel"
          @click="event().setPassAudit()">
          设置放行审批人</el-button>
        <el-button
          type="primary"
          class="excel"
          @click="network().getElectronicExcel()">
          导出Excel</el-button>
      </div>
    </Nav>
    <div class="type-change-box">
      <div class="box-name" v-for="(item,index) in titleBox" :key="index">
        <span
          :class="[item.select ? 'black' : '']"
          @click="event().changeStatus(item)">{{item.name}}</span>
      </div>
    </div>
    <table-pagination
        ref="table"
        :config="config"
        class="table"
        :datasource="datasource"
        @change-page-num="handlerPageNum"
        @change-page="handlerPageChange">
        <el-table-column
            slot="action"
            fixed="right"
            label="操作"
            width="250"
            align="center">
            <template slot-scope="scope">
              <div class="row">
                <span class="details" @click="event().putMeetingAppointment(1,scope)" v-if="scope.row.status === 0">通过</span>
                <span class="details" @click="event().putMeetingAppointment(4,scope)" v-if="scope.row.status === 0">拒绝</span>
              </div>
              <div class="row">
                <span class="details" @click="handlerPage('details',scope)">查看详情</span>
              </div>
            </template>
        </el-table-column>
    </table-pagination>
    <el-dialog
      :visible.sync="showDialog1"
      width="600px">
      <div class="dialog">
        <div class="title">
          <div>审批人</div>
          <div>(放行审批人拥有放行审批权利)</div>
        </div>
        <div class="audit-box">
          <span v-if="!auditInfo.wxAvatar">暂无审批人</span>
          <div class="img-box" v-else>
            <img :src="auditInfo.wxAvatar" alt="">
            <div class="name">{{auditInfo.wxName}}</div>
          </div>
        </div>
        <div class="btn-box">
          <el-button @click="showDialog1 = false">关闭</el-button>
          <el-button type="primary" @click="event().editor()">编辑</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showDialog2"
      width="1200px">
      <div class="dialog">
        <div class="title">
          <div>审批人</div>
          <div>(放行审批人拥有放行审批权利)</div>
        </div>
        <div class="table">
          <div class="search">
            <el-input
              v-model="UserBody.word"
              clearable
              placeholder="请输入昵称进行搜索"
              class="input"></el-input>
            <el-button type="primary" @click="event().userSearch()">搜索</el-button>
          </div>
          <table-pagination
            ref="table"
            :config="config1"
            class="table1"
            :idRow="true"
            :radio="true"
            :datasource="userDatasource"
            :selectRadio="selectRadio"
            @change-radio="handlerSelectAudit"
            @change-page-num="handlerPageNum1"
            @change-page="handlerPageChange1">
            <el-table-column
              slot="action"
              label="认证状态"
              align="center">
              <template slot-scope="scope">
                <div>
                  <span
                    v-if="scope.row.isAuthentication === 0">
                    {{ scope.row.isAuthentication | status }}</span>
                  <span
                    v-if="scope.row.isAuthentication === 1"
                    style="color:blue">
                    {{ scope.row.isAuthentication | status }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              slot="action"
              label="所属企业"
              align="center">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.enterpriseName === ''">-</span>
                  <span v-else>
                    {{ scope.row.enterpriseName}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              slot="action"
              label="注册时间"
              align="center">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.createTime }}</span>
                </div>
              </template>
            </el-table-column>
        </table-pagination>
        </div>
        <div class="btn-box">
          <el-button @click="event().back()">返回</el-button>
          <el-button type="primary" @click="event().setAudit()">设置审批人</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px">
      <div class="alert-content">
        <el-input
          type="textarea"
          show-word-limit
          placeholder="请填写拒绝原因"
          v-model="setBody.refusalReason"
          maxlength="100"
          :autosize="{ minRows: 10, maxRows: 20 }"/>
      </div>
      <div class="btn">
        <el-button type="primary" @click="event().putCommit()">提交</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import TablePagination from '@/components/table-pagination'
import Nav from '@/components/nav'
import { getElectronicExcel, getAuditList, setAudit, putElectronic } from '@/api/electronic'
import { getReleaseLog } from '@/api/company'
import { getUserList } from '@/api/user'
import utils from '@/jslib/utils'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        type: '',
        status: '',
        uuid: '',
        word: ''
      },
      putBody: { // 设置审批人请求体
        userUuid: ''
      },
      setBody: { // 电子放行审核操作请求体
        refusalReason: '',
        status: '',
        uuid: ''
      },
      UserBody: {
        pageSize: 5,
        pageIndex: 1,
        word: '',
        isAuthentication: ''
      },
      excelBody: {
        type: '',
        status: '',
        word: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'orderNum',
            label: '订单编号'
          },
          {
            prop: 'enterpriseName',
            label: '企业名称'
          },
          {
            prop: 'name',
            label: '联系人'
          },
          {
            prop: 'mobile',
            label: '电话号码'
          },
          {
            prop: 'offDate',
            label: '截止时间'
          },
          {
            prop: 'type',
            label: '类型',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '普通放行'
              },
              {
                value: 1,
                label: '退租放行'
              }
            ]
          },
          {
            prop: 'status',
            label: '状态',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '审核中'
              },
              {
                value: 1,
                label: '已通过'
              },
              {
                value: 2,
                label: '拒绝'
              }
            ]
          }
        ]
      },
      config1: {
        size: 5,
        fields: [
          {
            prop: 'wxAvatar',
            label: '头像',
            type: 'wx_image',
            width: '80px'
          },
          {
            prop: 'wxName',
            label: '昵称'
          }
        ]
      },
      titleBox: [
        {
          name: '全部',
          status: '',
          select: true
        },
        {
          name: '普通放行',
          status: 0,
          select: false
        },
        {
          name: '退租放行',
          status: 1,
          select: false
        }
      ],
      datasource: {
        total: 0,
        data: []
      },
      userDatasource: {
        total: 0,
        data: []
      },
      status: ['选择状态', '待审核', '已通过', '已拒绝'],
      selectStatus: '',
      auditInfo: {}, // 放行审批人信息
      selectAudit: [], // 所勾选的发行人信息
      selectRadio: [],
      showDialog1: false,
      showDialog2: false,
      dialogVisible: false
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) {
        return `未认证`
      } else return '已认证'
    }
  },
  mounted() {
    if (this.$route.params.id === ':id') {
      this.body.uuid = this.companyUuid
    } else {
      this.$store.commit('storeUuid', this.$route.params.id)
      this.body.uuid = this.$route.params.id
    }
    this.network().getReleaseLog()
  },
  methods: {
    event() {
      return {
        selectFn: (e) => {
          switch (e) {
            case '待审核' : this.body.status = 0; break
            case '已通过' : this.body.status = 1; break
            case '已拒绝' : this.body.status = 2; break
            case '选择状态' : this.body.status = ''; break
          }
          this.network().getReleaseLog()
        },
        search: () => {
          this.network().getReleaseLog()
        },
        changeStatus: (e) => {
          this.event().clearStatus()// 清除
          e.select = true// 赋值
          this.body.type = e.status
          this.network().getReleaseLog()
        },
        clearStatus: () => {
          this.titleBox.forEach(item => {
            item.select = false
          })
        },
        setPassAudit: () => {
          this.showDialog1 = true
          this.auditInfo = []
          this.network().getAuditList()
        },
        editor: () => {
          this.showDialog1 = false
          this.showDialog2 = true
          this.network().getUserList()
        },
        userSearch: () => {
          this.network().getUserList()
        },
        back: () => {
          this.showDialog2 = false
          this.event().setPassAudit()
        },
        setAudit: () => {
          if (this.selectAudit.length === 0 && !this.auditInfo) {
            this.$message({
              type: 'warning',
              message: '请选择审批人'
            })
            return
          }
          if (this.selectAudit.length === 0 && this.auditInfo) {
            this.putBody.userUuid = this.auditInfo.uuid
          } else this.putBody.userUuid = this.selectAudit.uuid
          this.network().setAudit()
        },
        putMeetingAppointment: (e, scope) => { // 待审核
          if (e === 1) {
            this.setBody.status = e
            this.setBody.uuid = scope.row.uuid
            this.network().putElectronic()
          } else if (e === 4) {
            this.dialogVisible = true
            this.setBody.status = e
            this.setBody.uuid = scope.row.uuid
          }
        },
        putCommit: () => { // 放行申请记录通过/拒绝操作
          if (!this.setBody.refusalReason) {
            window.vm.$message.error('请填写信息')
            return
          }
          console.log(this.setBody)
          this.network().putElectronic()
        }
      }
    },
    network() {
      return {
        getReleaseLog: async() => {
          const { data } = await getReleaseLog(this.body)
          this.datasource.data = data.list
          this.datasource.total = data.total
        },
        getElectronicExcel: async() => {
          this.excelBody.type = this.body.type
          this.excelBody.status = this.body.status
          this.excelBody.word = this.body.word
          const { data } = await getElectronicExcel(this.excelBody)
          utils.exportExcel(data, '导出电子放行excel')
        },
        getAuditList: async() => {
          const { data } = await getAuditList()
          this.auditInfo = data
        },
        getUserList: async() => {
          const { data } = await getUserList(this.UserBody)
          this.userDatasource.total = data.total
          this.userDatasource.data = data.list
          const approve = []
          data.list.forEach((item, index) => {
            if (this.auditInfo.uuid === item.uuid) {
              approve.push(index)
            }
          })
          this.selectRadio = approve
        },
        setAudit: async() => {
          await setAudit(this.putBody.userUuid)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.showDialog2 = false
          this.showDialog1 = false
          this.network().getReleaseLog()
        },
        putElectronic: async() => {
          await putElectronic(this.setBody)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.dialogVisible = false
          this.network().getReleaseLog()
        }
      }
    },
    handlerPage(type, scope) {
      if (type === 'details') {
        console.log(scope)
        this.$router.push(`/company-management/release-log/get/${this.$route.params.id}/details/get/${scope.row.uuid}`)
      }
    },
    handlerPageNum(data) {
      this.body.pageSize = data.pageNum
      this.network().getReleaseLog()
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getReleaseLog()
    },
    handlerPageChange1(data) {
      this.UserBody.pageIndex = data.page
      this.network().getUserList()
    },
    handlerPageNum1(data) {
      this.UserBody.pageSize = data.pageNum
      this.network().getUserList()
    },
    handlerSelectAudit(data) {
      this.selectAudit = data.radioInfo
    }
  },
  components: {
    TablePagination,
    Nav
  },
  computed: {
    ...mapState({
      companyUuid(state) {
        return state.company.companyUuid
      }
    })
  }
}
</script>

<style scoped lang="scss">
.container{
  .left{
    .status{
      margin-left: 60px;
      span{
        margin-right: 15px;
      }
    }
  }

.type-change-box{
    margin: 15px 0;
    display: flex;
    .box-name{
      font-size: 20px;
      font-weight: bold;
      margin-right: 60px;
      color: rgb(163, 159, 159);
      span{
        cursor: pointer;
      }
    }
    .black{
      color: black;
    }
  }
  .dialog{
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: -30px;
      font-weight: bold;
      font-size: 20px;
      flex: 1;
    }
    .audit-box{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 90px 0;
      flex: 5;
      .img-box{
        display: flex;
        flex-direction: column;
        align-items: center
      }
      img{
        border-radius: 50%;
      }
      .name{
        margin-top: 30px;
        font-weight: bold;
        font-size: 20px
      }
    }
    .btn-box{
      flex: 1;
      margin: 15px 0;
      button{
        width: 150px;
      }
    }
    .table{
      width: 100%;
      display: flex;
      flex-direction: column;
      .search{
        width: 30%;
        display: flex;
        margin: 30px 0;
        .input{
          margin-right: 15px;
        }
      }
    }
  }
  .btn{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    button{
      width: 70%;
    }
  }
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}

/deep/ .table1{
  /deep/ .el-table__body .el-table__row{
    height: 100px;
  }
}
</style>
